// extracted by mini-css-extract-plugin
module.exports = {"wrapper-top-menu":"matchListContainer__wrapper-top-menu___2PDMb"};